import { ChevronDown, ChevronUp } from 'lucide-react'
import React from 'react'

interface AccordionProps {
  title: string
  isOpen?: boolean
  onToggle?: () => void
  children: React.ReactNode
}

export default function Accordion({
  title,
  isOpen: controlledIsOpen,
  onToggle,
  children,
}: AccordionProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  const open = controlledIsOpen ?? isOpen

  const handleClick = () => {
    if (onToggle) {
      onToggle()
    } else {
      setIsOpen(!isOpen)
    }
  }

  return (
    <div className="w-full">
      <button
        onClick={handleClick}
        className={`${open ? 'text-accent' : 'text-primary'} hover:text-accent bg-primary-light flex w-full items-center justify-center rounded-lg px-6 py-2.5 font-semibold uppercase transition-colors duration-300`}
      >
        <h2>{title}</h2>
        {open ? <ChevronUp /> : <ChevronDown />}
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          open
            ? 'max-h-96 translate-y-0 opacity-100'
            : 'max-h-0 -translate-y-2 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  )
}
